import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || 'your-supabase-url'
const supabaseKey = process.env.VUE_APP_SUPABASE_ANON_KEY || 'your-supabase-anon-key'

export const supabase = createClient(supabaseUrl, supabaseKey)

// Service requests functions
export const serviceRequests = {
  // Create new service request
  async create(request) {
    const { data, error } = await supabase
      .from('service_requests')
      .insert([request])
      .select()
    
    if (error) throw error
    return data[0]
  },
  
  // Get all service requests
  async getAll() {
    const { data, error } = await supabase
      .from('service_requests')
      .select('*')
      .order('created_at', { ascending: false })
    
    if (error) throw error
    return data
  }
}

// Reviews functions
export const reviews = {
  // Create new review
  async create(review) {
    const { data, error } = await supabase
      .from('reviews')
      .insert([review])
      .select()
    
    if (error) throw error
    return data[0]
  },
  
  // Get all approved reviews
  async getApproved() {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .eq('status', 'approved')
      .order('created_at', { ascending: false })
    
    if (error) throw error
    return data
  }
}